import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import { Roles } from '../../../core/util';
import get from 'lodash/get';
import FetchSelect from '../../../core/form/FetchSelect';
import Button from '../../../core/form/Button';

const CompanyListFilter = (props) => (
  <Row>
    <Column size={[Roles.ADMIN, Roles.SUPPORT].includes(localStorage.getItem('role')) ? 5 : 9}>
      <TextInput
        label="Name"
        value={get(props.values, 'name', null)}
        onChange={(value) => props.onChange('name', value)}
      />
    </Column>
    <Column size={2}>
      <TextInput
        label="Document Number"
        value={get(props.values, 'cnpj', null)}
        onChange={(value) => props.onChange('cnpj', value)}
      />
    </Column>
    <PermissionValidator allowedFor={[Roles.ADMIN, Roles.SUPPORT]}>
      <Column size={2}>
        <FetchSelect
          showSearch
          url="/segments"
          disabled={props.submitting}
          label="Segment"
          value={get(props.values, 'segment', '')}
          onChange={(segment) => props.onChange('segment', segment)}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={2}>
        <FetchSelect
          showSearch
          url="/distributors"
          label="Distributor"
          value={get(props.values, 'distributor')}
          onChange={(value) => props.onChange('distributor', value)}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
    </PermissionValidator>
    <Column size={1}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={() => props.onSearch()} />
    </Column>
  </Row>
);

CompanyListFilter.propTypes = {
  values: PropTypes.object,
  onSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CompanyListFilter;
